// Task 11 — /notes: operator-facing inbox for supervisor-directed notes.
import { useWsClient } from "@/lib/ws-provider";
import { isDirectedNoteActive } from "@capture/shared";
import { useDirectedNotes } from "../hooks/useDirectedNotes";
import { NoteInboxItem } from "../components/NoteInboxItem";
import styles from "../directed-notes.module.css";

export function NotesInboxPage() {
  const wsClient = useWsClient();
  const { notes, acknowledge } = useDirectedNotes(wsClient);
  const active = notes.filter(isDirectedNoteActive);
  const history = notes.filter((n) => n.acknowledgedAt);
  return (
    <div className={styles.page}>
      <header className={styles.pageHeader}><h1>Notes</h1></header>
      {active.length === 0 && history.length === 0 && (
        <p className={styles.empty}>No notes. Supervisors' directed notes to you appear here.</p>
      )}
      {active.map((n) => <NoteInboxItem key={n.id} note={n} onAcknowledge={acknowledge} />)}
      {history.length > 0 && (
        <>
          <h2 className={styles.sectionTitle}>Acknowledged (last 30 days)</h2>
          {history.map((n) => <NoteInboxItem key={n.id} note={n} onAcknowledge={acknowledge} />)}
        </>
      )}
    </div>
  );
}
